var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioFileIcon = function SvgAudioFileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillRule: "evenodd",
    d: "m10 19-3-3H3V8h4l3-3 2-2v18zm-3-5H5v-4h2.828l.586-.586L10 7.828v8.344l-1.586-1.586L7.828 14zm7 1h2V9h-2zm4 4h2V5h-2z",
    clipRule: "evenodd"
  })));
};
export { SvgAudioFileIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAxOUw3IDE2SDVIM1YxNFYxMFY4SDVIN0wxMCA1TDEyIDNWNS44Mjg0M1YxOC4xNzE2VjIxTDEwIDE5Wk03IDE0SDVWMTBIN0g3LjgyODQzTDguNDE0MjEgOS40MTQyMUwxMCA3LjgyODQzVjE2LjE3MTZMOC40MTQyMSAxNC41ODU4TDcuODI4NDMgMTRIN1pNMTQgMTVIMTZWOUgxNFYxNVpNMTggMTlIMjBWNUgxOFYxOVoiIGZpbGw9IiMyMTIxMjEiLz4KPC9zdmc+Cgo=";